var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 472C320 476.406 316.422 480 312 480H7.996C4.668 480 1.699 477.938 0.527 474.844C-0.66 471.75 0.199 468.219 2.684 466.032L229.14 264.412C280.828 219.82 286.828 144.353 242.905 92.48C221.108 66.731 190.373 51.075 156.404 48.419C122.326 45.731 89.325 56.418 63.544 78.605L29.7 107.729C26.356 110.636 21.309 110.261 18.418 106.886C15.528 103.542 15.918 98.48 19.262 95.605L53.106 66.481C82.138 41.513 119.466 29.45 157.654 32.45C195.92 35.481 230.53 53.137 255.124 82.168C304.781 140.791 298 226.132 239.671 276.443L29.012 464H312C316.422 464 320 467.594 320 472Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.aeaf6f3e79f8be0ef554fd083fc34d7b.svg";
export { ForwardRef as ReactComponent };